import './App.css';
import SingleCard from './Components/SingleCard';
import {useState,useEffect} from 'react'
const allImages=[
  {src:'./images/1.png',matched:false},
  {src:'./images/2.png',matched:false},
  {src:'./images/3.png',matched:false},
  {src:'./images/4.png',matched:false},
  {src:'./images/5.png',matched:false},
  {src:'./images/6.png',matched:false},
]

function App() {
  const [cards, setCards] = useState([]);
  const [turns, setTurns] = useState(0);
  const [choiceOne,setChoiceOne]=useState(null);
  const [choiceTwo,setChoiceTwo]=useState(null);
  const [disabled,setDisabled]=useState(false);

  //function to shuffle the cards
  const shuffleCards=()=>{
    const shuffledCards=[...allImages,...allImages]
      .sort(()=>{return Math.random()-0.5})
      .map((currCard)=>{return {...currCard,id:Math.random()}})
    
    setCards(shuffledCards);
    setTurns(0);
  };

  //function to reset choices
  const resetChoices=()=>{
    setChoiceOne(null);
    setChoiceTwo(null);
    setDisabled(false);
    setTurns((prevTurns)=>{return prevTurns+1})
  }
  //function for choices
  const handleChoices=(card)=>{
    choiceOne?setChoiceTwo(card):setChoiceOne(card);
  }

  //to handle after second choice
  useEffect(()=>{
    if(choiceOne && choiceTwo){
      setDisabled(true);
      if(choiceOne.src===choiceTwo.src){
        setCards((prevCards)=>{
          return prevCards.map((currCard)=>{
            if(currCard.src===choiceOne.src){
              return {...currCard,matched:true};
            }
            else{
              return currCard;
            }
          })
        })
      }
      else{
        console.log('different choice');
      }
      setTimeout(()=>{resetChoices()},1500);
    }
  },[choiceTwo])
  

  //to start the game initially
  useEffect(()=>{
    shuffleCards();
  },[])
  return (
    <div className="App">
      <h1>Card Memory Game</h1>
      <button onClick={shuffleCards}>New Game</button>
      <div className='card-grid'>
        {
          cards.map((currCard)=>{
              return (
                <SingleCard 
                  key={currCard.id}
                  card={currCard} 
                  handleChoices={handleChoices}
                  flipped={currCard==choiceOne || currCard==choiceTwo || currCard.matched===true}
                  disabled={disabled}
                />
              )
            })
        }
      </div>
      <p className='turns'>Total Turns : <span>{turns}</span></p>
    </div>
  );
}

export default App;
